module.exports = __webpack_public_path__ + "static/img/21_phase_function_Paper_PointsHejduk_Prediction.e4d3ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/21_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nwNd
// module chunks = 0